import { render } from "./DimensionBasicDataTab.vue?vue&type=template&id=28808604&ts=true"
import script from "./DimensionBasicDataTab.vue?vue&type=script&lang=ts"
export * from "./DimensionBasicDataTab.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__